module.exports = __webpack_public_path__ + "static/img/fangan2.854f61a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/fangan2.png
// module id = 9OuU
// module chunks = 1